import type { TrackEventProps } from "src/components/adobeAnalytics"

/*
 * There is a single Exposé concept with two entry points to generate it:
 * from an Offer (category "offer") and directly from a Stock Vehicle (category "inventory").
 * Each entry point emits an "open" event (modal mount) and a "create" event (Create clicked).
 */

// Entry point: Offer
export const TRACK_OPEN_CREATE_OFFER_EXPOSE: TrackEventProps = {
	action: "open_create_offer_expose",
	category: "offer",
}
export const TRACK_CREATE_OFFER_EXPOSE: TrackEventProps = { action: "create_offer_expose", category: "offer" }

// Entry point: Stock Vehicle
export const TRACK_OPEN_CREATE_VEHICLE_EXPOSE: TrackEventProps = {
	action: "open_create_vehicle_expose",
	category: "inventory",
}
export const TRACK_CREATE_VEHICLE_EXPOSE: TrackEventProps = { action: "create_vehicle_expose", category: "inventory" }
